import MidiaContainer from './midia.page'

export default MidiaContainer
